<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/user-listing'">User List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/daily-user-listing'">Daily User List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/monthly-user-listing'">Monthly User List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/yearly-user-listing'">Yearly User List</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/user-listing'">User List</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/daily-user-listing'">Daily User List</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/monthly-user-listing'">Monthly User List</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/yearly-user-listing'">Yearly User List</li>
                        </ol>
                    </nav>
                </div>
                <!-- <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/user-add" >
                            Add User
                        </a>                       
                    </div>
                </div> -->
            </div>
            <div class="row align-items-end">
                <div class="col-12 col-sm-4 col-lg-3 pb-3">
                    <label for="inputState" class="form-label">Search</label>
                    <input type="text" id="inputState" class="form-control" placeholder="Search By Name" [(ngModel)]='searchKey' (keyup)="p=1;getDetail(p)">
                </div>
                <div class="col-12 col-sm-4 col-lg-3 pb-3">
                    <label for="inputState" class="form-label">Status</label>
                    <select id="inputState" class="form-select" [(ngModel)]='statuskey' (change)="p=1;getDetail(p)">
                        <option value="Active">Active</option>
                        <option value="In-Active">In-Active</option>
                        <!-- <option value="Accept">Accepted</option>
                        <option value="CancelByUser">Cancelled By User</option>
                        <option value="CancelByProvider">Cancelled By Provider</option>
                        <option value="CancelByAdmin">Cancelled By Admin</option> -->
                    </select>
                </div>

                <div class="col-12 col-sm-4 col-lg-3 pb-3 pt-sm-4">
                    <button type="button" class="btn custom-btn btn-danger px-4" (click)="reset()">Reset</button>
                </div>
              
                <div class="col-12">
                    <div class="card">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Full Name</th>
                                        <!-- <th scope="col">Last Name</th>                                        -->
                                        <th scope="col">Email</th>
                                        <th scope="col">DOB</th>
                                        <!-- <th scope="col">Generation</th> -->
                                        <th scope="col">Status</th>
                                        <th scope="col">Detail </th>
                                        <!-- <th scope="col">Detail</th>
                                        <th scope="col">Delete</th> -->
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td><img [src]="item.image" style="height:30px;width:30px"></td>
                                        <td>{{item.fullName}}</td>
                                        <!-- <td>{{item.lastName}}</td>  -->
                                        <td>{{item.email}}</td>                                        
                                        <td>{{item.dob}}</td> 
                                        <td>
                                            <span class="btn btn-success" *ngIf="item.status =='Active'" (click)="redirect(item,4)" style="cursor: pointer;">{{item.status}}</span>
                                            <span class="btn btn-danger" *ngIf="item.status =='In-Active'" (click)="redirect(item,4)" style="cursor: pointer;">In-Active</span>
                                        </td>
                                        <td>
                                            <div class="box-btn">
                                                <!-- <button type="button" title="Edit" class="btn btn-info text-center me-2" (click)="redirect(item,3)">
                                                    <i class="bx bx-pencil" ></i>
                                                </button> -->
                                                <button type="button" title="View" class="btn btn-primary text-center me-2" (click)="redirect(item,1)">
                                                    <i class="bx bx-show" ></i>
                                                </button>
                                                <!-- <button type="button" title="Delete" class="btn btn-danger text-center" (click)="redirect(item,2)">
                                                    <i class="bx bx-trash" ></i>
                                                </button> -->
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>

<!-- Cancel Popup Modal -->

<button type="button" class="btn gradient1-btn custom-btn me-3" data-bs-toggle="modal" data-bs-target="#WriteReson" id="text3" class="d-none"> </button>

<div class="modal fade" id="WriteReson" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-body">
                <div class="popup-content-box text-center p-4">
                    <div class="popup-content pt-4">
                        <h5 class="title m-0"> Share your Reason </h5>

                        <div class="custom-form pt-4">
                            <form>
                                <div class="row justify-content-center">
                                    <div class="col-12 pt-3">
                                        <div class="form-group pb-4">
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Reason" [(ngModel)]="reasons" [ngModelOptions]="{standalone: true}"></textarea>
                                            <!-- <label class="text-capitalize" for="FullName"> Reason </label> -->
                                        </div>
                                    </div>
                                </div>

                                <div class="form-btn">
                                    <button class="btn custom-btn gradient1-btn me-5" (click)="delete()"> Submit </button>
                                    <button class="btn custom-btn dark-btn" data-bs-dismiss="modal" data-bs-toggle="modal" id="cclosebtn"> Close </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
